<template>
    <div class="main-container">
        <p>A continuación se muestra la información de las estaciones que proveen los datos ambientales para el departamento de Caldas</p>
        <div class="main-container-table" v-for="(item, index) in typologyStationsList" :key="index">
            <h2 :class="['accordion-title', {'open': item.open}]" @click="toggleAccordion(index)">{{ item.title }}</h2>
            <div class="container-table">
                <table v-if="item.open" class="table">
                    <thead class="table-header">
                        <tr>
                            <th class="table-row-title" v-for="(column, columnIndex) in columns" :key="columnIndex">{{ column.name }}</th>
                        </tr>
                    </thead>
                    <tbody class="table-body">
                        <tr v-for="(row, rowIndex) in item.content" :key="rowIndex">
                            <td class="table-row-content" v-for="(column, columnIndex) in columns" :key="columnIndex">{{ row[column.key] }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="button-container">
            <button class="show-send" @click="downloadData()">Descargar listado de información de estaciones</button>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
    name: 'HomeAccordion',
    data (){
        return{
            typology: '',
            typologyStationsList: [
            {
                title: 'ESTACIONES CLIMATOLÓGICAS',
                content: [],
                open: false
            },
            {
                title: 'ESTACIONES DE CALIDAD DEL AIRE',
                content: [],
                open: false
            },
            {
                title: 'ESTACIONES AGUAS SUBTERRÁNEAS',
                content: [],
                open: false
            }
            ],
            columns: [
            {key: 'idSimac', name: 'ID'},
            {key: 'name', name: 'Nombre de estación'},
            {key: 'municipality', name: 'Municipio'},
            {key: 'location', name: 'Ubicación'},
            {key: 'altitude', name: 'Altitud'},
            {key: 'start_operation', name: 'Fecha inicio de funcionamiento'},
            ]
        }
    },
    methods: {
        ...mapActions(['getStationsInformation', 'downloadStationsInformation']),
        async toggleAccordion(index) {
            const item = this.typologyStationsList[index];
            switch (index) {
            case 0:
                this.typology = 'hydrometeorological'
                break;
            case 1:
                this.typology = 'airQuality'
                break;
            case 2:
                this.typology = 'groundWater'
                break;
            default:
                break;
            }
            if (item.content.length === 0) {
                item.content = await this.getStationsInformation(this.typology)
                item.open = !item.open
            } else {
                item.open = !item.open
            }
        },
        downloadData(){
            this.downloadStationsInformation()
        }
    }
}
</script>
<style scoped>
p{
    text-align: center;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
}
.main-container{
    margin-left: 7em;
    display: flex;
    flex-direction: column;
}
.main-container-table{
    max-width: 70%;
    margin-left: 12rem;
    flex-wrap: row wrap;
}
/* accordion title cards */
.accordion-title{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: none;
  background-color: #bdbdbd46;
  padding: 0.8em;
}
.accordion-title:hover{
  background-color: #94b43b;
  text-decoration: underline;
}
.accordion-title::after {
  content: "\f078";
  font-family: "FontAwesome";
  float: right;
  margin-left: 5px;
}

.accordion-title.open::after {
  transform: rotate(180deg);
}
/* Style table */
.container-table{
  display: grid;
  overflow: auto;
  max-height: 40rem;
  max-width: auto;
  font-size: 0.8rem;
  text-align: center;
}
.table {
  border: .1rem solid rgba(220, 220, 220, 0.74);
}
.table-header, 
  td {
    vertical-align: middle;
  }
.table-body {
  line-height: 1;
  color: black;
  overflow: auto;
}
.table-row-title {
  border-left: .1rem solid gainsboro;
  min-width:6rem;
  font-family: "Ancizar-regular", Helvetica, Arial;
}
.table-row-content {
  font-family: "Ancizar-regular", Helvetica, Arial;
  border-left: .1rem solid rgba(220, 220, 220, 0.616);
  border-bottom: .1rem solid rgba(220, 220, 220, 0.616);
}
/* style dowloand button */
.button-container {
    display: flex;
    margin-top: 1.5rem;
    margin-left: 12rem;
}
.show-send {
    border-radius: 0.5rem;
    padding: 0.6rem;
    color: white;
    background-color: #777777;
}
</style>